import { render } from "./NewInstance.vue?vue&type=template&id=93e5b088&scoped=true"
import script from "./NewInstance.vue?vue&type=script&lang=js"
export * from "./NewInstance.vue?vue&type=script&lang=js"

import "./NewInstance.vue?vue&type=style&index=0&id=93e5b088&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93e5b088"]])

export default __exports__